var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoAddToCart = function SvgIcoAddToCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ico_add_to_cart_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ico_add_to_cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.961 17.965q-.607 0-1.032-.426a1.4 1.4 0 0 1-.426-1.033q0-.607.426-1.033a1.4 1.4 0 0 1 1.032-.425q.608 0 1.033.425.426.426.426 1.033 0 .608-.426 1.033a1.4 1.4 0 0 1-1.033.426m8.078 0q-.608 0-1.033-.426a1.4 1.4 0 0 1-.426-1.033q0-.607.426-1.033a1.4 1.4 0 0 1 1.033-.425q.607 0 1.032.425.426.426.426 1.033 0 .608-.426 1.033a1.4 1.4 0 0 1-1.032.426M5.012 4.792l2.112 4.423h5.681q.072 0 .128-.036a.3.3 0 0 0 .096-.1l2.236-4.063q.048-.088.008-.156-.04-.069-.136-.068zm-.6-1.25h11.571q.51 0 .773.435.262.435.025.888l-2.67 4.837q-.205.36-.542.562a1.4 1.4 0 0 1-.74.2H6.75l-.965 1.763q-.064.097-.004.209t.18.112h9.536v1.25H5.96q-.833 0-1.252-.719-.42-.718-.03-1.435l1.19-2.138-3.032-6.381H1.25v-1.25h2.372z"
  }))));
};
export default SvgIcoAddToCart;